/* @flow weak */
import enumerate from 'lib/enumerate';

const CURRENCIES = enumerate([
  'USD',
  'EUR',
]);

export default CURRENCIES;



// WEBPACK FOOTER //
// ./src/lib/Currencies.js